/**
 * Список полей, которые исключаются при создании ПМ через fetchKnmCreate (для кейса создания копии паспорта),
 * но будут включены при сохранении в черновик через knmDraftSave (тк в черновик мы можем сохранить любые данные, исключая валидацию на беке).
 *
 * Это позволяет избежать ошибки создания паспорта / копии паспорта (на основе ставших невалиднымми данных), для которых требуется внесение изменений со стороны пользователя (на фронте)
 * или дополнительных данных до момента сохранения в черновик.
 *
 * Поддерживает как верхнеуровневые поля, так и вложенные:
 * - Верхнеуровневые: 'pmErknm'
 * - Вложенные: 'pmErknm.requirements',
 *
 */
export const CREATE_DRAFT_EXCLUDED_FIELDS = ['pmErknm.requirements'];
